// Function to remove content after the slash
function waitForElement(selector, trigger, delayInterval, delayTimeout) {
    var interval = setInterval(function () {
        if (document && document.querySelector(selector) && document.querySelectorAll(selector).length > 0) {
            clearInterval(interval);
            trigger();
        }
    }, delayInterval);
    setTimeout(function () {
        clearInterval(interval);
    }, delayTimeout);
}

function updateRatingSnippet() {
    const ratingElement = document.querySelectorAll('.ruk_rating_snippet');
    const secondSpan = document.querySelectorAll('.ruk_rating_snippet span:nth-of-type(2)');
    console.log("data get!!", secondSpan);
    // Check if the second span exists
    ratingElement.forEach((ele)=>{
        ele.style.visibility = "visible";
    })
    secondSpan.forEach((ele)=>{
        ele.innerHTML = ele.innerHTML.replace(/ \/ .*/, '');
    })
}

document.addEventListener("DOMContentLoaded", (event) => {
    console.log("load the page!!");
    waitForElement(".ruk_rating_snippet", updateRatingSnippet, 350, 5000);   
    waitForElement(".R-ReviewsList", showSliderArrow, 350, 5000);   
     
});


function showSliderArrow() {
    document.querySelector('.R-ReviewsList__controlButton--right').addEventListener('click', function(){
        document.querySelector('.R-ReviewsList__controlButton--left').style.display = "block";
    });
    document.querySelectorAll('.R-ReviewsList__item').forEach(function(item) {
        let touchStartX = 0;
        let touchEndX = 0;

        // Listen for the start of the touch
        item.addEventListener('touchstart', function(event) {
            touchStartX = event.changedTouches[0].screenX;
        });

        // Listen for the end of the touch
        item.addEventListener('touchend', function(event) {
            touchEndX = event.changedTouches[0].screenX;
            handleSwipe();
        });

        // Function to determine if it was a swipe left or right
        function handleSwipe() {
            if (touchEndX < touchStartX) {
                console.log('Swiped left');
                document.querySelector('.R-ReviewsList__controlButton--left').style.display = "block";
            }
            if (touchEndX > touchStartX) {
                console.log('Swiped right');
                document.querySelector('.R-ReviewsList__controlButton--left').style.display = "block";
            }
        }
    });
};